














































































































import { fetchEnrolleeProgress } from '@adobe/edex/frontend/api/course';
const MODAL_WIDTH = 656;

export default {
  name: 'enrollee-progress-modal',
  data() {
    return {
      enrollee: null,
      progress: null,
      loading: false,
      error: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    beforeOpen(e) {
      this.enrollee = e.params.enrollee;
      this.progress = null;
      this.fetchProgress();
    },
    async fetchProgress() {
      this.loading = true;
      try {
        const { data } = await fetchEnrolleeProgress(
          this.enrollee.courseID,
          this.enrollee.memberID
        );

        this.progress = data;
      } catch (error) {
        this.error = true;
        console.log(error);
      }

      this.loading = false;
    },
  },
};
